module.exports = __webpack_public_path__ + "static/media/ipad-pro-12.9-availabird-edit-availability-range-reduced.f84242cf.png";